"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHandlerSettingsBase = void 0;
class HttpHandlerSettingsBase {
    constructor() {
        /**
         * Fetch API Request timeout
         *
         * @default 10000
         */
        this.AlmeApiRequestTimeout = 10000;
        /**
         * Alme REST API post authorization request endpoint path.
         *
         * @default "Authorization"
         */
        this.AlmeApiAuthorizationEndpoint = 'Authorization';
        /**
         * @default 120
         */
        this.AlmeAuthorizationExpireBufferSeconds = 120;
    }
}
exports.HttpHandlerSettingsBase = HttpHandlerSettingsBase;
//# sourceMappingURL=HttpHandlerSettingsBase.js.map


// WEBPACK FOOTER //
// ../HttpHandlerSettingsBase.ts